export default function ProductGalleryScreen() {
  return (
    <div>
      <h1>En construcción</h1>
    </div>
  );
}
